if (!window.Eurus.loadedScript.includes('frequently-bought-together.js')) {
  window.Eurus.loadedScript.push('frequently-bought-together.js');

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data('xFrequentlyBought', (
        itemsElId,
        currencyCode,
        locale,
        recommendationsUrl,
        currentCategoryHandles
      ) => ({
        items: [],
        selected: [],
        loading: false,
        errorMessage: '',
        // Phase 2A tier 3: categories the current product belongs to (pipe-delimited,
        // cross-cutting merchandising collections already excluded server-side).
        currentCategories: new Set((currentCategoryHandles || '').split('|').filter(Boolean)),
        init() {
          const el = document.getElementById(itemsElId);
          this.items = el ? JSON.parse(el.textContent) : [];
          this.selected = this.items.filter((item) => item.available).map((item) => item.variantId);

          if (recommendationsUrl) {
            this.loadRecommendations(recommendationsUrl);
          }
        },
        // Phase 2A tier 3: an automatic recommendation only qualifies as a fallback
        // if it shares a real category collection with the current product. If the
        // current product has no category signal at all, we show no fallback items
        // rather than guess - manual/metafield picks (tiers 1-2) are unaffected.
        isCategoryRelevant(item) {
          if (!this.currentCategories.size) {
            return false;
          }
          const itemCategories = (item.collections || '').split('|').filter(Boolean);
          return itemCategories.some((handle) => this.currentCategories.has(handle));
        },
        loadRecommendations(url) {
          fetch(url)
            .then((response) => response.text())
            .then((text) => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const script = html.querySelector('#fbt-recommendations-json');
              if (!script) {
                return;
              }
              const recommended = JSON.parse(script.textContent);
              const existingIds = new Set(this.items.map((item) => item.productId));
              const newItems = recommended.filter((item) => !existingIds.has(item.productId) && this.isCategoryRelevant(item));
              if (!newItems.length) {
                return;
              }
              this.items = [...this.items, ...newItems];
              this.selected = [...this.selected, ...newItems.filter((item) => item.available).map((item) => item.variantId)];
            })
            .catch((error) => {
              console.error('Error loading FBT recommendations:', error);
            });
        },
        toggle(variantId) {
          if (this.selected.includes(variantId)) {
            this.selected = this.selected.filter((id) => id !== variantId);
          } else {
            this.selected = [...this.selected, variantId];
          }
        },
        get selectedItems() {
          return this.items.filter((item) => this.selected.includes(item.variantId));
        },
        get totalPrice() {
          return this.selectedItems.reduce((sum, item) => sum + item.price, 0);
        },
        get totalComparePrice() {
          return this.selectedItems.reduce((sum, item) => sum + (item.compareAtPrice > item.price ? item.compareAtPrice : item.price), 0);
        },
        get hasSavings() {
          return this.totalComparePrice > this.totalPrice;
        },
        formatMoney(cents) {
          try {
            return new Intl.NumberFormat(locale, { style: 'currency', currency: currencyCode }).format(cents / 100);
          } catch (e) {
            return (cents / 100).toFixed(2);
          }
        },
        addSelectedToCart() {
          if (!this.selected.length || this.loading) {
            return;
          }

          this.loading = true;
          this.errorMessage = '';

          const items = this.selected.map((id) => ({ id, quantity: 1 }));

          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ items, sections: Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id) })
          }).then((response) => {
            return response.json();
          }).then((response) => {
            if (response.status === 422) {
              this.errorMessage = response.description;
              return;
            }

            Alpine.store('xCartHelper').getSectionsToRender().forEach((section) => {
              const sectionElement = document.querySelector(section.selector);

              if (sectionElement && response.sections[section.id]) {
                sectionElement.innerHTML = getSectionInnerHTML(response.sections[section.id], section.selector);
              }
            });

            if (Alpine.store('xQuickView') && Alpine.store('xQuickView').show) {
              Alpine.store('xQuickView').show = false;
            }
            Alpine.store('xMiniCart').openCart();
            const cartIconBubble = document.querySelector('#cart-icon-bubble span');
            if (cartIconBubble) {
              Alpine.store('xCartHelper').currentItemCount = parseInt(cartIconBubble.innerHTML);
            }
            document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
          }).catch((error) => {
            console.error('Error:', error);
            this.errorMessage = 'Something went wrong. Please try again.';
          }).finally(() => {
            this.loading = false;
          });
        }
      }));
    });
  });
}
